import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { TestChatBadge } from './TestChatBadge';
import { formatDateTime } from '@/lib/format';
import type { Thread } from '@/types/chat';

interface ChatListTableProps {
  threads: Thread[];
  onSelect: (threadId: string) => void;
  isLoading?: boolean;
}

const SKELETON_ROWS = 5;

export function ChatListTable({ threads, onSelect, isLoading = false }: ChatListTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-24">Tipo</TableHead>
            <TableHead>Número</TableHead>
            <TableHead>Última mensagem</TableHead>
            <TableHead className="w-28 text-right">Mensagens</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading && (
            <>
              {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
                <TableRow key={`skeleton-${i}`}>
                  <TableCell><Skeleton className="h-5 w-16" /></TableCell>
                  <TableCell><Skeleton className="h-5 w-36" /></TableCell>
                  <TableCell><Skeleton className="h-5 w-40" /></TableCell>
                  <TableCell><Skeleton className="h-5 w-10 ml-auto" /></TableCell>
                </TableRow>
              ))}
            </>
          )}

          {!isLoading && threads.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} className="text-center py-10 text-muted-foreground">
                Nenhuma conversa encontrada
              </TableCell>
            </TableRow>
          )}

          {!isLoading &&
            threads.map((thread) => (
              <TableRow
                key={thread.id}
                className="cursor-pointer hover:bg-muted/50"
                onClick={() => onSelect(thread.id)}
              >
                <TableCell>
                  <TestChatBadge isTestChat={thread.isTestChat} />
                </TableCell>
                <TableCell className="font-mono text-sm">{thread.phoneNumber}</TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {formatDateTime(thread.lastMessageAt)}
                </TableCell>
                <TableCell className="text-right text-sm">{thread.messageCount > 0 ? thread.messageCount : '—'}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  );
}
